export const HOME = '/'
export const LOGIN = '/login'
export const SETTINGS = '/settings'
export const AIRCRAFTS = '/aircrafts'
export const CALENDAR = '/calendar'
export const TESTS = '/tests'
export const USERS = '/users'
